<template>
    <IntegrationSettingsCard icon="fas fa-cogs" :title="__('general.settings')">
        <template v-slot:body>
            <div class="d-flex flex-column flex-md-row align-items-center gap-4 gap-md-10">
                <div>
                    <label class="font-weight-bold text-xl m-0 opacity-50">{{ __('form.host') }}</label>
                    <div class="text-lg">{{ formData.opentrans_ftp_host }}</div>
                </div>
                <div>
                    <label class="font-weight-bold text-xl m-0 opacity-50">{{ __('general.user') }}</label>
                    <div class="text-lg">{{ formData.opentrans_ftp_user }}</div>
                </div>
                <div>
                    <label class="font-weight-bold text-xl m-0 opacity-50">{{ __('form.password') }}</label>
                    <div class="text-lg">
                        <HiddenText :value="formData.opentrans_ftp_password"/>
                    </div>
                </div>
            </div>
        </template>
    </IntegrationSettingsCard>
</template>

<script>
import IntegrationsSettingsLayout from "@layouts/IntegrationsSettingsLayout.vue";
import IntegrationSettingsCard from "@components/Integrations/IntegrationSettingsCard.vue";
import HiddenText from "@components/Form/HiddenText.vue";

export default {
    components: {HiddenText, IntegrationSettingsCard},

    layout: IntegrationsSettingsLayout,

    props: {
        integration: Object,
        formData: Object,
    }
}
</script>
